/**
 * Toques curtos via Web Audio (sem arquivo).
 * Precisa de um gesto do usuário uma vez para desbloquear o áudio.
 */

let audioCtx = null;
let unlocked = false;
let lastMessagePlayAt = 0;
let lastQueuePlayAt = 0;

function getCtx() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  return audioCtx;
}

function withAudio(run) {
  const ctx = getCtx();
  if (!ctx) return;

  const go = () => {
    unlocked = true;
    run(ctx);
  };

  if (ctx.state === 'suspended') {
    ctx
      .resume()
      .then(go)
      .catch(() => {});
    return;
  }
  go();
}

function makeBeep(ctx, master, freq, start, dur, type = 'sine') {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.9, start + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain);
  gain.connect(master);
  osc.start(start);
  osc.stop(start + dur + 0.02);
}

/** Chamar em clique/tecla no painel para liberar áudio em background. */
export function unlockNotifyBeep() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  unlocked = true;
}

/**
 * Blim de nova mensagem (dois tons ascendentes agudos).
 * Ignora spam (< 700ms).
 */
export function playNotifyBeep() {
  const now = Date.now();
  if (now - lastMessagePlayAt < 700) return;
  lastMessagePlayAt = now;

  withAudio((ctx) => {
    const t0 = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.0001, t0);
    master.gain.exponentialRampToValueAtTime(0.55, t0 + 0.018);
    master.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.36);
    master.connect(ctx.destination);

    makeBeep(ctx, master, 880, t0, 0.11, 'sine');
    makeBeep(ctx, master, 880, t0, 0.1, 'triangle');
    makeBeep(ctx, master, 1245, t0 + 0.11, 0.14, 'sine');
    makeBeep(ctx, master, 1245, t0 + 0.11, 0.12, 'triangle');
  });
}

/**
 * Toque de fila (três pulsos médios, mais “alerta”).
 * Diferente do blim de mensagem. Ignora spam (< 900ms).
 */
export function playQueueBeep() {
  const now = Date.now();
  if (now - lastQueuePlayAt < 900) return;
  lastQueuePlayAt = now;

  withAudio((ctx) => {
    const t0 = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.0001, t0);
    master.gain.exponentialRampToValueAtTime(0.6, t0 + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.55);
    master.connect(ctx.destination);

    // Pulsos: grave → médio → médio-agudo (timbre square suave)
    const pulse = (freq, start) => {
      makeBeep(ctx, master, freq, start, 0.09, 'triangle');
      makeBeep(ctx, master, freq * 0.5, start, 0.08, 'sine');
    };

    pulse(523, t0);
    pulse(659, t0 + 0.14);
    pulse(784, t0 + 0.28);
  });
}

export function isNotifyBeepUnlocked() {
  return unlocked;
}
